import { forwardRef } from "react";
import { Text } from "../Text/Text";

export type TextAreaProps = {
  value?: string;
  onChange: (text: string) => void;
  onEnterPressed?: () => void;

  label?: string;
  helperText?: string;
  description?: string;
  placeholder: string;
  disabled?: boolean;

  id?: string;
  className?: string;
  containerClassName?: string;
  width?: string | number;
  height?: string | number;
  minHeight?: string | number;
  standardRows?: number;
  autoFocus?: boolean;

  marginTop?: number;

  resize?: "all" | "vertical" | "horizontal" | "none";

  dataCy?: string;
};

/**
 * @deprecated use TextArea from ui-components instead
 */
export const TextArea = forwardRef(({ description, disabled, label, helperText, ...props }: TextAreaProps, ref: any) => {
  const inputStyles: React.CSSProperties = {};
  if (props.resize !== "all") inputStyles.resize = props.resize;
  if (props.minHeight) inputStyles.minHeight = props.minHeight;

  return (
    <div style={{ display: "flex", alignItems: "center", marginTop: props.marginTop }}>
      {description && <Text size={"md"} text={description} marginRight="0.5em" />}

      <div className={props.containerClassName} style={{ width: props.width ?? "200px", height: props.height }}>
        {label && <Text text={label} size={"sm"} marginBottom={2}></Text>}
        <textarea
          ref={ref}
          disabled={disabled}
          id={props.id}
          className={`textarea ${props.className ?? ""}`}
          placeholder={props.placeholder}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          rows={props.height ? 1 : (props.standardRows ?? 3)}
          style={{ ...inputStyles, width: "100%" }}
          onKeyDown={(event) => {
            if (event.keyCode === 13) props.onEnterPressed?.();
          }}
          autoFocus={props.autoFocus}
          data-cy={props.dataCy}
        />
        {helperText && <Text text={helperText} size={"sm"} color="secondary" marginTop={4}></Text>}
      </div>
    </div>
  );
});
